import React, { PropTypes } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import * as logEntryActions from '../actions/logEntryActionCreators';

require.ensure([], () => {
    require('./Material-Design-Iconic.less');
    require('./Pills.less');
    require('./TimerPill.less');
});

class TimerPill extends React.Component {

    constructor(props, context) {
        super(props, context);

        this.props.getPill(this);

        this.state = {
            mouseOver: false,
            startTime: moment(),
            duration: "",
            durationHours: 0,
            durationInitialRefresh: setTimeout(this.refreshTimeShown, 200),
            durationRefresh: setInterval(this.refreshTimeShown, 20000)
        };
    }

    // LIFECYCLE METHODS

    componentWillReceiveProps = (nextProps) => {
        this.setState({
            logEntry: nextProps.logEntry,
            startTime: moment(nextProps.logEntry.startTime, ["HH:mm:ss", "HH:mm"])
        }, this.refreshTimeShown);
    }

    componentWillUnmount = () => {
        clearInterval(this.state.durationRefresh);
        clearTimeout(this.state.durationInitialRefresh);
    }

    // EVENT HANDLERS

    handleMouseOut = (event) => {
        this.setState({
            mouseOver: false
        });
    }

    handleMouseOver = (event) => {
        this.setState({
            mouseOver: true
        });
    }

    // OTHER METHODS

    refreshTimeShown = () => {
        let startTime = this.state.startTime;

        // sometimes componentWillReceiveProps is not called so we get a bad moment object with current time
        // which doesn't have the field '_i' set with the time
        if (!startTime['_i']) {
            startTime = moment(this.props.logEntry.startTime, ["HH:mm:ss", "HH:mm"]);

            this.setState({
                startTime: startTime
            });
        }

        let currentTime = moment();
        let difference = 60 * (currentTime.hours() - startTime.hours()) + currentTime.minutes() - startTime.minutes();
        let hours = Math.floor(difference / 60);
        let minutes = difference % 60;

        // show negative as zero
        if (hours < 0)
            hours = "0";

        // add the leading zero
        if (hours < 10)
            hours = "0" + hours;

        // show negative as zero
        if (minutes < 0)
            minutes = "0";

        // add the leading zero
        if (minutes < 10)
            minutes = "0" + minutes;

        let duration = hours + ":" + minutes;

        this.setState({
            duration: duration,
            durationHours: parseInt(hours)
        });
    }

    stopTimer = () => {
        // we set these fields so we can optimistically update the user screen
        this.props.logEntry.timer = false;

        if (this.props.logEntry.startTime) {
            let currentTime = moment();
            let startTime =  moment(this.props.logEntry.startTime, ["HH:mm:ss", "HH:mm"]);
            this.props.logEntry.duration = Math.floor(60 * (currentTime.hours() - startTime.hours())
                                                        + (currentTime.minutes() - startTime.minutes()));
        }

        if (this.props.editForUser) {
            this.props.logEntry.userID = this.props.editForUser.id;
        }

        if (this.props.currentUser) {
            this.props.logEntry.lastModifiedByUser = this.props.currentUser.givenName + " " + this.props.currentUser.surname + " (" + this.props.currentUser.username + ")";
        }

        this.props.logEntry.lastModifiedAt = moment().format("YYYY-MM-DD[T]H:mm:ss");

        this.props.dispatch(logEntryActions.stopTimer(this.props.logEntry));
        setTimeout(this.props.loadTimesheet, 500);
    }

    // RENDER METHOD

    render = () => {
        if (this.props.logEntry == null)
            return null;

        let className = "task with-timer";

        if (!this.props.logEntry.projectName) {
            className += " floating";
        }

        let pillStyles = {};

        if (this.props.logEntry.projectName) {
            pillStyles['borderLeft'] = "10px solid " + this.props.logEntry.color;
        } else {
            pillStyles['borderLeft'] = "10px solid #777777";
        }

        let clockStyle = {};

        if (this.props.logEntry.projectName) {
            clockStyle['color'] = this.props.logEntry.color;
        } else {
            clockStyle['color'] = "#777777";
        }

        let paddingHeight = (this.state.durationHours + 1) * 20;

        return (
            <li style={pillStyles}>
                <div className={className} style={{paddingBottom: paddingHeight + "px"}}>
                    <h4>{ this.props.logEntry.projectName ? this.props.logEntry.projectName : "Floating Task" }</h4>
                    <h5 title={this.props.logEntry.alias ? this.props.logEntry.taskName : null}>{ this.props.logEntry.alias ? this.props.logEntry.alias : this.props.logEntry.taskName } </h5>
                </div>
                <div className="timer-on" onMouseOver={this.handleMouseOver} onMouseOut={this.handleMouseOut}>
                    {
                        this.state.mouseOver
                        ? <span><i className="md-alarm-off md-2x" onClick={this.stopTimer} ></i></span>
                        : <span><i className="md-alarm md-2x timer-active" style={clockStyle} onClick={this.stopTimer} ></i></span>
                    }
                    <br/>
                    <span className="time-show" style={clockStyle}>{this.state.duration}</span>
                </div>
            </li>
        );
    }
}

TimerPill.propTypes = {
    children: PropTypes.element,
    currentUser: PropTypes.object,
    createLogEntry: React.PropTypes.func,
    dispatch: PropTypes.func,
    updateLogEntry: React.PropTypes.func,
    logEntry: React.PropTypes.object.isRequired
};

const mapStateToProps = (state) => {
    return {
        currentUser: state.users.currentUser,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        dispatch: dispatch
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(TimerPill);



/** WEBPACK FOOTER **
 ** ./src/app/components/TimerPill.js
 **/